// Confirmed production origin. Keep preview hosts out of canonical URLs.
export const SITE_URL = 'https://bansow.net';
export const SITE_NAME = '株式会社BanSow';
export const DEFAULT_OG_IMAGE = 'https://static.readdy.ai/image/6dc6f75b646bd407cab498a59b7fe71f/5023a65fd13a246be1c370c51194b6da.png';
export const SITE_LOGO = 'https://static.readdy.ai/image/6dc6f75b646bd407cab498a59b7fe71f/0f5077bc1a4731335df9383c524ad875.png';

